webpackJsonp([177],{

/***/ 1178:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": "为什么部分组件要加`x-`前缀 | VUX - Vue 移动端 UI 组件库", "ignoreSuffixChar": "|" }
});

/***/ }),

/***/ 1993:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(1178),
  /* template */
  __webpack_require__(2231),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/runner/work/vux/vux/docs/node_modules/v-markdown-loader/_cache/why-use-x-prefix-for-components-26.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] why-use-x-prefix-for-components-26.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4deadf78", Component.options)
  } else {
    hotAPI.reload("data-v-4deadf78", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2231:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("为什么部分组件要加"), _c('code', [_vm._v("x-")]), _vm._v("前缀")]), _vm._v(" "), _c('p', [_vm._v("若不更名，可能在开发时与标准 html 标签相同而导致冲突或者 bug，比如 "), _c('code', [_vm._v("Dialog")]), _vm._v(", "), _c('code', [_vm._v("Switch")]), _vm._v(" 等。从Vue@2.x开始已经强制不能使用原生html标签。")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4deadf78", module.exports)
  }
}

/***/ }),

/***/ 602:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1993);

/***/ })

});


// WEBPACK FOOTER //
// 177.92a66d2b.js